import { Outlet } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { SplitHeroShell } from './SplitHeroShell';

export function SplitHeroLayout(): ReactElement {
    return (
        <SplitHeroShell contentMaxWidth={360}>
            <Outlet />
        </SplitHeroShell>
    );
}
